<h1 class="page-title">
  {{ mode === "edit" ? "Edit Group" : "Create New Group" }}
</h1>

<div class="card-container">
  <app-card title="Group Information">
    <form [formGroup]="groupFormGroup" (ngSubmit)="onsubmit()">

      <!-- Group Name -->
      <mat-form-field appearance="outline">
        <mat-label>Group Name</mat-label>
        <input
          matInput
          formControlName="groupName"
          placeholder="Enter group name"
          />
      </mat-form-field>

      <p>Time Period of Tracking</p>
      <div class="tracking-period-container">
        <mat-form-field appearance="outline">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="trackingPeriod">
            <input
              matStartDate
              placeholder="Start date"
              formControlName="trackingPeriodStart"
              />
            <input
              matEndDate
              placeholder="End date"
              formControlName="trackingPeriodFinish"
              />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matIconSuffix
            [for]="trackingPeriod"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #trackingPeriod></mat-date-range-picker>
        </mat-form-field>
      </div>
      <!-- Information Box: -->
      @if (mode === 'create') {
        <app-card>
          <div class="info-text">
            <app-icon name="info" color="black"></app-icon>
            After creating a group, the invitation code will appear on the group
            detail page. Share it with your students so they can join easily.
          </div>
        </app-card>
      }

      <!-- Submit Button -->
      <div>
        <button class="btn">
          <app-icon [name]="mode === 'edit' ? 'edit_notes' : 'plus'"></app-icon>
          {{ mode === "edit" ? "Save changes" : "Create new group" }}
        </button>
      </div>
    </form>
  </app-card>
</div>